import BaseInterestRateService from '@/services/retailer/BaseInterestRateService.js'

import { BASE_INTEREST_RATE_ERROR_MESSAGES } from '../../../constants/errorMessages'

export const allowedFilters = ['retailer_id']
export const allowedSorts = '-created_at'
export const allowedIncludes = ''
export const allowedAppends = ''

export const namespaced = true

export const state = {
  interestRateImage: null,
  interestRateImageMustBeSeen: false,
  isInterestRateImageUploaded: false,
  interestRateImageUrl: null
}

export const mutations = {
  SET_BASE_INTEREST_RATES_IMAGE(state, interestRates) {
    state.interestRateImage = interestRates.interestRateImage
    state.interestRateImageMustBeSeen = interestRates.interestRateImageMustBeSeen
    state.isInterestRateImageUploaded = interestRates.isInterestRateImageUploaded
    state.interestRateImageUrl = interestRates.interestRateImageUrl
  }
}

export const actions = {
  getInterestRateImageSettings({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      BaseInterestRateService.getInterestRateImageSettings()
        .then(response => {
          commit('SET_BASE_INTEREST_RATES_IMAGE', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: BASE_INTEREST_RATE_ERROR_MESSAGES.notFoundError
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
